import React from "react";
import Preloader from "../helper/Preloader";
 import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
 import ScrollToTop from "react-scroll-to-top";
import CartSectionAmazon from "../componentsAmazon/CartSectionAmazon";
import HeaderOneVendorStore from "../componentsAmazon/HeaderOneVendorStore";
import FooterOne from "../components/FooterOne";


const CartPageAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneVendorStore /> 

      {/* CartSection */}
      <CartSectionAmazon />
 

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default CartPageAmazon;
